<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level App Configuration
          <!-- <a href="https://www.notion.so/Banners-765409d6e99f4e61b22e163b4237fc9f" target="_blank"
                        class="ml-2">
                        <vs-icon icon="info" size="small" />
                    </a> -->
        </h3>
        <p class="card-subtitle">
          {{ activeTab === "appConfig" ? "List of Registered Apps used for Promotions" : "View and Manage App Reviews" }}
        </p>

        <!-- Tabs Section -->
        <div class="tabOptions">
          <button :class="{ active: activeTab === 'appConfig' }" @click="switchTab('appConfig')" color="primary" class="mr-2">
            App configuration
          </button>
          <button :class="{ active: activeTab === 'appReviews' }" @click="switchTab('appReviews')" color="primary" class="mr-2">App Reviews/Autoreply Configs</button>
        </div>

        <!-- Tab Content Section -->
        <div v-if="activeTab === 'appConfig'">
          <appConfig />
        </div>
        <div v-if="activeTab === 'appReviews'">
          <appReviews />
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import appConfig from "./app.vue";
import AppReviews from "./appReviews.vue";

export default {
  name: "appMainSwitch",
  components: {
    appConfig,
    appReviews:AppReviews,
  },
  data() {
    return {
      activeTab: "appConfig",
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped>
.tabOptions {
  display: flex;
  font-size: larger;
  font-weight: bolder;
}

.tabOptions button {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.tabOptions button.active {
  border-bottom: 2px solid #007bff; /* Color for the active tab */
  color: #007bff; /* Text color for the active tab */
}

.tabOptions button:hover {
  color: #0056b3; /* Text color on hover */
}

.tabOptions button:focus {
  outline: none; /* Remove default outline on focus */
}
</style>
